import React, { useState } from 'react';
import { Slide } from '../Slide';
import { InView } from '../InView';
import { SlideHeadline } from '../SlideHeadline';
import { WebsiteSnakDemo } from '../WebsiteSnakDemo';
const steps = [{
  key: 'A',
  title: 'The invitation',
  caption: 'A compact teaser on the existing page invites visitors to start a short experience.'
}, {
  key: 'B',
  title: 'The Snak opens',
  caption: 'One click opens an immersive window above the website. Close it anytime, or follow links to the product information.'
}];
export function SnakkerfySlide() {
  const [open, setOpen] = useState(false);
  const activeKey = open ? 'B' : 'A';
  return <Slide id="snakkerfy" data-id="element-373" data-mp="3tl6iv5ayi62h">
      <div className="grid items-end gap-8 lg:grid-cols-[minmax(0,1fr)_380px] lg:gap-16" data-id="element-374" data-mp="3tlyf8icdo7tt">
        <InView data-id="element-375" data-mp="1vvx2o6ko4z9n">
          <SlideHeadline lead="Same website." follow="A more effortless experience." data-id="element-376" data-mp="1vudm0ev3om7c" />
        </InView>
        <InView delay={0.1} data-id="element-377" data-mp="1ruv3tqunyp87">
          <p className="font-body text-[14.5px] leading-[1.7] text-[rgba(1,51,43,0.65)]" data-id="element-378" data-mp="1rule84dj6k31">
            Today, visitors navigate, search, scroll and read to discover the Filtek
            portfolio. What if we also offered them a lean-back option?
          </p>
          <span className="mt-4 inline-flex rounded-full bg-background px-3.5 py-1.5 font-body text-[10px] uppercase tracking-[0.16em] text-primary" data-id="element-379" data-mp="2cbom9ieus4sk">
            Practical pilot · Optional layer · No redesign
          </span>
        </InView>
      </div>

      <InView delay={0.15} className="mt-12" data-id="element-380" data-mp="3445j5eplq9zg">
        <div className="mx-auto max-w-[1180px]" data-id="element-381" data-mp="38zujvldcxwxc">
          <WebsiteSnakDemo open={open} onOpenChange={setOpen} data-id="element-382" data-mp="392qht9p7glls" />
        </div>
      </InView>

      <InView delay={0.22} data-id="element-383" data-mp="2v7epf8yiv781">
        <div className="mx-auto mt-6 grid max-w-[1180px] gap-3 sm:grid-cols-2" data-id="element-384" data-mp="2zaulo46oj5k7">
          {steps.map(step => {
          const active = step.key === activeKey;
          return <button key={step.key} type="button" onClick={() => setOpen(step.key === 'B')} aria-pressed={active} className={['flex items-start gap-4 rounded-[18px] p-4 text-left transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary', active ? 'bg-white ring-1 ring-[rgba(1,51,43,0.12)]' : 'hover:bg-white/60'].join(' ')} data-id="element-385" data-mp="3rrdn9tbanczw">
                <span className={['flex h-8 w-8 shrink-0 items-center justify-center rounded-full font-heading text-[14px] transition-colors', active ? 'bg-background text-primary' : 'border border-[rgba(1,51,43,0.25)] text-background'].join(' ')} data-id="element-386" data-mp="3io9o7clvx9i4">
                  {step.key}
                </span>
                <span data-id="element-387" data-mp="2zwp99deoczn6">
                  <span className="block font-heading text-[18px] leading-tight text-background" data-id="element-388" data-mp="3004nyf4fs6o2">
                    {step.title}
                  </span>
                  <span className="mt-1 block max-w-[46ch] font-body text-[13px] leading-relaxed text-[rgba(1,51,43,0.58)]" data-id="element-389" data-mp="2kvs7zxldri9z">
                    {step.caption}
                  </span>
                </span>
              </button>;
        })}
        </div>
      </InView>

      <InView delay={0.3} data-id="element-390" data-mp="2zssyjxru576v">
        <div className="mt-14 flex flex-col gap-3 border-t border-[rgba(1,51,43,0.12)] pt-8 lg:flex-row lg:items-baseline lg:justify-between lg:gap-10" data-id="element-391" data-mp="2zr803x2eh43q">
          <p className="font-heading text-[26px] leading-[1.1] tracking-[-0.02em] text-background sm:text-[32px]" data-id="element-392" data-mp="273lqa72kx38f">
            Lean forward when you want to. Lean back when you prefer to.
          </p>
          <p className="max-w-[36ch] font-body text-[13px] leading-relaxed text-[rgba(1,51,43,0.58)]" data-id="element-393" data-mp="2gtf0b3n2paak">
            The Snak complements the existing website rather than replacing it.
          </p>
        </div>
      </InView>
    </Slide>;
}